// Banner no topo do cardápio do totem: imagens largas cadastradas em
// Cardápio → Banners → Totem → "Cardápio de produtos" (até 5). Troca a cada
// 5 s com fade e pontos. Sem imagem, não ocupa espaço. Recarrega a cada 10 min.
import { useEffect, useState } from "react";

import { bannerImageUrl } from "../../cardapio-banners/lib/bannerImageUrl";
import { totemApi } from "../api";

const TROCA_MS = 5000;
const RECARREGAR_MS = 10 * 60 * 1000;

export default function BannerCardapio() {
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let vivo = true;
    const carregar = async () => {
      try {
        const r = await totemApi.bannersCardapio();
        const lista = (Array.isArray(r.data) ? r.data : []).filter((b) => b.enabled && b.image_url);
        if (vivo) { setBanners(lista); setIdx((i) => (lista.length ? i % lista.length : 0)); }
      } catch (_) { /* banner é enfeite */ }
    };
    carregar();
    const t = setInterval(carregar, RECARREGAR_MS);
    return () => { vivo = false; clearInterval(t); };
  }, []);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % banners.length), TROCA_MS);
    return () => clearInterval(t);
  }, [banners.length]);

  if (banners.length === 0) return null;
  const atual = banners[idx];
  return (
    <div className="px-3 pt-3" data-e2e="banner-cardapio" data-idx={idx}>
      <div className="relative w-full aspect-[7/2] max-h-64 rounded-2xl overflow-hidden bg-zinc-900 border border-zinc-800">
        <img key={atual.id} src={bannerImageUrl(atual.image_url)} alt={atual.title || ""} className="w-full h-full object-cover banner-cardapio-fade" />
        {banners.length > 1 && (
          <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
            {banners.map((b, i) => (
              <button key={b.id} type="button" onClick={() => setIdx(i)} aria-label={`Banner ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-1.5 bg-white/50"}`} />
            ))}
          </div>
        )}
        <style>{`
          @keyframes banner-cardapio-fade { from { opacity: 0; } to { opacity: 1; } }
          .banner-cardapio-fade { animation: banner-cardapio-fade 600ms ease-out both; }
        `}</style>
      </div>
    </div>
  );
}
